import { capitalize } from '@ember/string';
import Component from '@glimmer/component';

import type { Billing } from 'webapp-types';
import { BillingInvoiceStatus as Status } from 'webapp/enums/enums';

interface Args {
	model: Billing.Invoice;
	extendedView?: boolean;
}

export default class BillingInvoiceRowComponent extends Component<Args> {
	get invoiceClass(): string {
		let className = '';
		switch (this.args.model.status) {
			case Status.PAID:
				className = 'green';
				break;
			case Status.DUE:
				className = 'red';
				break;
		}
		return className;
	}

	get statusTextCapitalized(): string {
		return capitalize(this.args.model.status);
	}
	<template>
		<div class="invoices__row">
			<div class="invoices__column">
				<div>
					{{#if @model.pdfLink}}
						<a href={{@model.pdfLink}} target="_blank">
							{{#if @extendedView}}
								{{@model.receiptNumber}}
							{{else}}
								{{@model.dateFormatted}}
							{{/if}}
						</a>
					{{else}}
						{{#if @extendedView}}
							{{@model.receiptNumber}}
						{{else}}
							{{@model.dateFormatted}}
						{{/if}}
					{{/if}}
				</div>
			</div>
			{{#if @extendedView}}
				<div class="invoices__column">{{@model.dateFormatted}}</div>
			{{/if}}
			<div class="invoices__column total">
				{{@model.amountDueFormatted}}
			</div>
			<div class="invoices__column">
				<span class={{this.invoiceClass}}>{{this.statusTextCapitalized}}</span>
			</div>
		</div>
	</template>
}
